import cookies from 'js-cookie';
import { requester } from '../utils';

export const login = (userName, password) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/loginByUserNamePass`,
        method: 'POST',
        withAuth: false,
        data: {
          userName,
          password
        }
      })
      .then(result => {
        console.log('login successfully', result);
        cookies.set('auth-token', result.payload.authToken, { expires: 60 /*0.03125*/ });
        resolve(result.payload);
      })
      .catch(err => {
        console.log('login error', err);
        reject(err);
      });
  });
};

export const getMeInfo = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/me`,
        method: 'POST'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const sendMobileNumber = mobileNumber => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/forgetPassword`,
        method: 'POST',
        data: {
          mobileNumber
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const checkVerificationCode = (verificationCode, mobileNumber) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/verifySetNewPassword`,
        method: 'POST',
        data: {
          mobileNumber,
          verificationCode
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const sendNewPassword = (password, mobileNumber, resetPassToken) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/auth/panel/reset-password`,
        method: 'PUT',
        data: {
          mobileNumber,
          password,
          resetPassToken
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
